import { BaseController } from '../../common/base/controller';
import { OwnerModel } from './owner.model';
import { TransferType } from '../transfer/transfer.constants';
import { DEMO_DATA_NEW_USER, DEMO_DATA_OLD_USER } from './demo';
import { omit } from 'lodash';

export class OwnerController extends BaseController {
  MAX_OWNERS = 2;

  get isProd() {
    return this.configService.isProduction();
  }

  get isPSD() {
    return this.envService.getTenant().indexOf('psd') >= 0;
  }

  get featureUserEmail() {
    return this.configService.isFeatureActive(this.Features.userEmail);
  }

  get showAddNewOwner() {
    return this.newOwners.length < 2;
  }

  get showDeadline() {
    return this.isPSD;
  }

  get transferAllSecurities() {
    const oldPortfolio = this.appCache.get('oldPortfolio');
    return oldPortfolio && oldPortfolio.transferAllSecurities;
  }

  get transferInheritance() {
    return this.isTransferType(TransferType.inheritance);
  }

  get transferGift() {
    return this.isTransferType(TransferType.gift);
  }

  get transferOwnAccount() {
    return this.isTransferType(TransferType.ownAccount);
  }

  get transferOwnAccountHint() {
    return this.transfer && this.transfer.ownAccountInfo;
  }

  constructor(controllerService, configService) {
    'ngInject';
    super({ controllerService, configService });
  }

  $onInit() {
    this.oldOwners = this.appCache.get('oldOwners') || [new OwnerModel()];
    this.newOwners = this.appCache.get('newOwners') || [new OwnerModel()];
    this.transfer = this.appCache.get('transfer');
    this.ownersForm = {};
    this.deadlineDateOptions = {
      dateFormat: 'dd.MM.yyyy',
      minDate: new Date(),
    };
    this.deadline = new Date();
  }

  next() {
    this.ownersForm.$submitted = true;
    if (!this.ownersForm.$valid) {
      return;
    }
    this.setOwnersData();
    this.nextState();
  }

  prev() {
    if (this.ownersForm.$valid) {
      this.setOwnersData();
    }

    // Since we skip the newPortfolio state if the user transfers all securites
    // we need to skip newPortfolio state backwards as well
    this.transferAllSecurities ? this.go('app.transfer') : this.prevState();
  }

  addOldOwner() {
    if (this.oldOwners.length < 2) {
      this.oldOwners.push(new OwnerModel({ isAdditionalOwner: true }));
    }
  }

  addNewOwner() {
    if (this.newOwners.length < 2) {
      this.newOwners.push(new OwnerModel({ isAdditionalOwner: true }));
    }
  }

  removeOldOwner() {
    if (this.oldOwners.length > 1) {
      this.oldOwners.pop();
    }
  }

  removeNewOwner() {
    if (this.newOwners.length > 1) {
      this.newOwners.pop();
    }
  }

  setOwnersData() {
    this.appCache.set('deadline', this.deadline);
    this.appCache.set('oldOwners', this.oldOwners);
    this.appCache.set('newOwners', this.newOwners);
  }

  hideEmailOldOnwersForm(owner) {
    // show email on old owner despite being nachlass
    return (
      this.transferInheritance ||
      !this.featureUserEmail ||
      owner.isAdditionalOwner
    );
  }

  hideEmailNewOnwersForm(owner) {
    // show email on new owner when being nachlass or if owner is not changeing
    return (
      (!this.transferInheritance && !this.transferOwnAccount) ||
      !this.featureUserEmail ||
      owner.isAdditionalOwner
    );
  }

  isTinRequired() {
    const isTinRequiredFeature = this.configService.isFeatureActive(
      this.Features.isTinRequired,
    );
    return (
      isTinRequiredFeature || this.transferGift || this.transferInheritance
    );
  }

  isTransferType(type) {
    return this.appCache.get('transfer').type === type;
  }

  demo() {
    this.newOwners = this.getDemoUser(DEMO_DATA_NEW_USER);

    if (!this.transferOwnAccount) {
      this.oldOwners = this.getDemoUser(DEMO_DATA_OLD_USER);
    }
  }

  getDemoUser(data) {
    return data.map((user) => {
      if (!this.isTinRequired()) {
        user = omit(user, 'tin');
      }
      return new OwnerModel(user);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/owner/owner.controller.js